import { alpha } from '@material-ui/core/styles'

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`
}

// SETUP COLORS
const PRIMARY = {
  lighter: '#B3CFFE',
  light: '#4D8FFC',
  main: '#015ffb',
  dark: '#0151D5',
  darker: '#0143B0',
  opposite: '#fff',
}
const SECONDARY = {
  lighter: '#B2C0C8',
  light: '#4D6D7E',
  main: '#002E47',
  dark: '#00273C',
  darker: '#002032',
  opposite: '#fff',
}
const INFO = {
  lighter: '#CEE6FF',
  light: '#8EC6FF',
  main: '#5DADFF',
  dark: '#4F93D9',
  darker: '#4179B2',
  opposite: '#fff',
}
const SUCCESS = {
  lighter: '#BFF1CE',
  light: '#69E08E',
  main: '#29D25D',
  dark: '#23B34F',
  darker: '#1D9341',
  opposite: '#fff',
}
const WARNING = {
  lighter: '#FEE2B3',
  light: '#FCBA4D',
  main: '#FB9D01',
  dark: '#D58501',
  darker: '#B06E01',
  opposite: '#fff',
}
const ERROR = {
  lighter: '#FAC6C7',
  light: '#F27B7D',
  main: '#ED4245',
  dark: '#C9383B',
  darker: '#A62E30',
  opposite: '#fff',
}
const DARK = {
  lighter: '#D0D5D9',
  light: '#929DA7',
  main: '#637381',
  dark: '#54626E',
  darker: '#45515A',
  opposite: '#fff',
}
const DISABLED = {
  lighter: '#DEE2E6',
  light: '#B2BBC4',
  main: '#919EAB',
  dark: '#7B8691',
  darker: '#666F78',
  opposite: '#fff',
}
const WHITE = {
  lighter: '#FBFBFB',
  light: '#F7F7F7',
  main: '#FFFFFF',
  dark: '#BEC7D0',
  darker: '#919EAB',
  opposite: '#002E47',
}

const GRAY = {
  lighter: '#E5E7EB',
  light: '#DBDEE3',
  main: '#CBD0D7',
  dark: '#ABB2BE',
  darker: '#838D98',
  opposite: '#fff',
}

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
}

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
}

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY, contrastText: '#fff' },
  secondary: { ...SECONDARY, contrastText: '#fff' },
  info: { ...INFO, contrastText: '#fff' },
  success: { ...SUCCESS, contrastText: '#fff' },
  warning: { ...WARNING, contrastText: '#fff' },
  dark: { ...DARK, contrastText: '#fff' },
  disabled: {
    ...DISABLED,
    contrastText: '#fff',
  },
  error: { ...ERROR, contrastText: '#fff' },
  white: { ...WHITE, contrastText: GREY[800] },
  gray: { ...GRAY, contrastText: GREY[800] },

  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
}

const palette = {
  // LIGHT MODE
  light: {
    ...COMMON,
    mode: 'light',
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: {
      paper: '#fff',
      default: '#fff',
      neutral: GREY[200],
    },
    action: {
      active: GREY[600],
      ...COMMON.action,
    },
  },

  // DARK MODE
  dark: {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#fff',
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: GREY[500_16],
    },
    action: {
      active: GREY[500],
      ...COMMON.action,
    },
  },
}

export default palette
